<div class="col-xs-12 time-info">
  <span class="pull-left waiting-time"><span class="time-label">Waiting time:</span><span class="time-value">{{ waitTime }}</span></span>
  <span class="pull-right current-time"><span class="time-label">Current time:</span><span class="time-value"><!-- {{ _systemData.currentTimeDisplay24hFormat }} --></span></span>
</div>